<template>
<div class="form-users" v-if="entity">
  <div v-if="entity.users && entity.users.length">
    <table class="table b-table b-table-stacked-lg">
      <thead>
        <tr>
          <th>Usuário</th>
          <th>Email</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in entity.users" :key="index">
          <td>
            {{user.name}}
          </td>
          <td>
            {{user.email}}
          </td>
          <td class="text-right">
            <div class="btn-group btn-group-sm">
              <a v-if="entity.users.length > 1" @click="remove(user._id)" class="btn btn-secondary">
                <i class="fa fa-close"></i>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <no-item :list="entity.users" />
  </div>
  <a v-if="!form" class="btn btn-default btn-sm pull-right" @click="addUser">Adicionar usuário</a>
  <div v-if="form" >
    <div class="row">
      <div class="col-md-4 col-sm-6">
        <b-form-group>
          <b-form-input v-model="form.name" type="text" placeholder="Nome" @keydown.enter.prevent="saveUser" />
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6">
        <b-form-group>
          <b-form-input v-model="form.email" type="text" placeholder="Email" @keydown.enter.prevent="saveUser" />
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6">
        <b-form-group>
          <b-form-input v-model="form.password" type="password" placeholder="Senha" @keydown.enter.prevent="saveUser" />
        </b-form-group>
      </div>
    </div>
    <span v-if="form.name && form.email && form.password" class="btn btn-primary btn-sm pull-right" @click="saveUser">Salvar usuário</span>
  </div>
  <div class="clearfix"></div>
  <b-alert variant="danger" show v-if="error">{{error}}</b-alert>
</div>
</template>

<script>
import axios from 'axios'
import NoItem from '@/components/NoItem'

export default {

  name: 'form-users',
  props: ['organization', 'supplier'],
  data() {
    return {
      form: null,
      users: [],
      entity: null,
      empty_form: {
        name: "",
        email: "",
        password: "",
        organization: null,
        supplier: null,
        cnpj: "",
        roles: []
      }
    }
  },
  created() {
    if (this.organization) {
      this.entity = this.organization
    } else if (this.supplier) {
      this.entity = this.supplier
    }
  },
  methods: {
    addUser() {
      this.form = this.empty_form
      this.error = null
    },
    saveUser() {
      if (this.form.email, this.form.name && this.form.password) {
        if (this.organization) {
          this.form.organization = this.organization._id
          this.form.cnpj = this.organization.cnpj
          this.form.roles = ["manager"]
        } else if (this.supplier) {
          this.form.supplier = this.supplier._id
          this.form.cnpj = this.supplier.cnpj
          this.form.roles = ["supplier"]
        }
      }

      axios({
        method: 'POST',
        url: 'users',
        data: this.form
      }).then(resp => {
        var user = resp.data
        if (user && user._id) {
          if (this.organization) {
            this.organization.users.push(user)
          } else if (this.supplier) {
            this.supplier.users.push(user)
          }
          this.notify('Usuário cadastrado com sucesso!')
          this.form = null
        }
      }).catch(this.showError)
    },
    remove(id) {
      if (confirm("Tem certeza que deseja excluír?")) {
        axios.delete('users/' + id).then(() => {
          this.entity.users = this.entity.users.filter(user => {
            return user._id != id
          })
        }).catch(this.showError)
      }
    }
  },
  components: {
    NoItem
  }
};
</script>
